/**
 * 
 * Right.js
 * 
 */

 import React, { Component } from 'react'
import { Container } from 'react-bootstrap';
 

 export default class Right extends Component {

    static diplayName = Right.name;


     render() {


         return (


             <Container style={{ backgroundColor: '', paddingRight: '0px', paddingBottom: '0px',  height: '80%', width: '10' }}>
                 
                <img
                src='/assets/image/about.png'
                height="125%"
                width="115%"
                alt="home"
                />

             </Container>


         );


     }


 }

